import { ErrorBoundary } from 'react-error-boundary';
import { Box, VStack } from '@chakra-ui/react';

import { BankAccountClosedError } from 'common/errors';
import useCurrentBankAccountId from 'common/hooks/useCurrentBankAccountId';
import Heading from 'components/_core/Heading';
import BackButton from 'components/BackButton';
import BankAccountPicker from 'components/BankAccountPicker';
import ErrorCard from 'components/ErrorCard';
import IbanPreview from 'features/Bank/components/IbanPreview';
import * as Layout from 'layouts/ContentLayout';

import locales from './locales';

const BankAccountDetails = () => {
  const {
    currentBankAccountId,
    loadingCurrentBankAccountId,
    mainBankAccountId,
    setCurrentBankAccountId,
  } = useCurrentBankAccountId({ shouldFallbackToMainBankAccount: true });

  const handleBankAccountChange = (bankAccountId: string | undefined) => {
    setCurrentBankAccountId(bankAccountId);
  };

  const handleIbanPreviewError = (error: Error) => {
    if (error instanceof BankAccountClosedError) {
      setCurrentBankAccountId(mainBankAccountId);
    }
  };

  return (
    <Layout.Root>
      <Layout.Body>
        <VStack alignItems="flex-start" spacing="space-32">
          <BackButton />
          <Heading size="lg">{locales.title}</Heading>

          <BankAccountPicker
            key={currentBankAccountId}
            onBankAccountChange={handleBankAccountChange}
            selectedBankAccountId={currentBankAccountId}
          />
        </VStack>
        <Box paddingTop="space-16">
          <ErrorBoundary
            fallback={<ErrorCard />}
            onError={handleIbanPreviewError}
            resetKeys={[currentBankAccountId]}
          >
            <IbanPreview
              bankAccountId={currentBankAccountId}
              loading={loadingCurrentBankAccountId}
            />
          </ErrorBoundary>
        </Box>
      </Layout.Body>
    </Layout.Root>
  );
};

export default BankAccountDetails;
